"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserAlreadyExistsError extends client_library_1.ExtendableError {
    constructor(userId) {
        super(`user already exists: ${userId}`);
    }
}
exports.default = UserAlreadyExistsError;
//# sourceMappingURL=UserAlreadyExistsError.js.map